import { render, staticRenderFns } from "./EventHeader.vue?vue&type=template&id=3c490e4b&scoped=true"
import script from "./EventHeader.vue?vue&type=script&lang=ts"
export * from "./EventHeader.vue?vue&type=script&lang=ts"
import style0 from "./EventHeader.vue?vue&type=style&index=0&id=3c490e4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c490e4b",
  null
  
)

export default component.exports